var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu - Close",
    clipPath: "url(#clip0_1151_37128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M4.93555 24V21.3333H22.2689V24H4.93555ZM4.93555 17.3333V14.6667H26.2689V17.3333H4.93555ZM4.93555 10.6667V8H22.2689V10.6667H4.93555Z",
    fill: "white",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M26.8021 9.33342L33.4688 16.0001L26.8021 22.6667L24.9354 20.8001L29.7354 16.0001L24.9354 11.2001L26.8021 9.33342Z",
    fill: "#03C988"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1151_37128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.935547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuDark);
export default __webpack_public_path__ + "static/media/close-menu-dark.66126252cb0e4edf7c6d192f84c2f9cb.svg";
export { ForwardRef as ReactComponent };